import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/storage-hub/capture-storage/")({
  staticData: {
    title: "titles.captureStorage",
  },
});
